import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import type { ApiError } from '@/entities/api-response/types';

import { changePassword } from '../api/changePassword';
import type { ChangePasswordPayload } from '../model/auth.schema';

export function useChangePassword(): UseMutationResult<void, ApiError, ChangePasswordPayload> {
  return useMutation({
    mutationFn: changePassword,
  });
}
